import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import messages from '../src/i18n/index'
import VueI18n from 'vue-i18n'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
//import VueMobileDetection from "vue-mobile-detection";

Vue.use(Buefy)
Vue.use(VueI18n)
//Vue.use(VueMobileDetection);

const i18n = new VueI18n({
  //locale: 'es', // set locale
  messages, // set locale messages
})

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
